import { useCallback } from "react";

interface WindowWithGoatCounter extends Window {
  goatcounter: {
    count({ path, title, event }: { path: string; title?: string; event: boolean }): void;
  };
}

export const useGoatCounter = () => {
  return useCallback((path: string, title?: string) => {
    if (
      "goatcounter" in window &&
      typeof (window as unknown as WindowWithGoatCounter).goatcounter === "object" &&
      (window as unknown as WindowWithGoatCounter).goatcounter !== null &&
      "count" in (window as unknown as WindowWithGoatCounter).goatcounter &&
      typeof (window as unknown as WindowWithGoatCounter).goatcounter === "function"
    ) {
      (window as unknown as WindowWithGoatCounter).goatcounter.count({
        path: path,
        title: title,
        event: true,
      });
    }
  }, []);
};
